var map = {
	"./Bronze.svg": 888,
	"./Diamond.svg": 889,
	"./Gold.svg": 890,
	"./Silver.svg": 891,
	"./company-default.png": 158,
	"./dummy.jpg": 217,
	"./dummy_profile.jpg": 114,
	"./icons8-whatsapp.svg": 84,
	"./invoice-sign": 260,
	"./invoice-sign.js": 260,
	"./videoimg.png": 273
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 212;